import { render, staticRenderFns } from "./eachticketdetail.vue?vue&type=template&id=bde6fae0&"
import script from "./eachticketdetail.vue?vue&type=script&lang=js&"
export * from "./eachticketdetail.vue?vue&type=script&lang=js&"
import style0 from "./eachticketdetail.vue?vue&type=style&index=0&id=bde6fae0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports